var render = function render(){var _vm=this,_c=_vm._self._c;return _c('defaultSec',{attrs:{"title":'< 订单详情',"returnState":true}},[_c('orderDetailInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }